import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin, Facebook } from "lucide-react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="logo">
              <Link to="/" style={{ color: "inherit" }}>
                <img
                  src="/images/logo.png"
                  alt="Relax Logo"
                  className="logo-img"
                />
              </Link>
            </div>
            <p className="footer-tagline">Peace in Your Pocket.</p>
          </div>
          <div className="footer-links">
            <Link to="/about">About Us</Link>
            <a href="/#features">Features</a>
            <a href="/#how-it-works">How It Works</a>
            <a href="/#testimonials">Reviews</a>
            <a href="/#contact">Contact Support</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Relax Infinity App. All rights
            reserved.
          </p>
          <div className="social-links">
            <a
              href="https://www.facebook.com/relaxinfinity"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a>
            <a
              href="https://x.com/relaxxapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <Twitter size={20} />
            </a>
            <a
              href="https://www.instagram.com/relaxinfinityapp/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/relaxinfinity?trk=public_profile_topcard-current-company"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
